/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dlh_WindowsInputs */

const en_wc_dlh_windows = /** @type {(inputs: Wc_Dlh_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 10 and 11. Signed .msi installer or portable .zip, for x64, ARM64 and 32-bit PCs.`)
};

/**
* | output |
* | --- |
* | "Windows 10 and 11. Signed .msi installer or portable .zip, for x64, ARM64 and 32-bit PCs." |
*
* @param {Wc_Dlh_WindowsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dlh_windows = /** @type {((inputs?: Wc_Dlh_WindowsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dlh_WindowsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dlh_windows(inputs)
});
export { wc_dlh_windows as "wc.dlh.windows" }